import axios from 'axios';

const OrganizationMenusAPI = {
  /**
   * Get menus for an organization
   * @param {number} organizationId - Organization ID
   * @param {Object} params - Query parameters (page, limit, sort, dir)
   * @returns {Promise}
   */
  getMenus(organizationId, params = {}) {
    return axios.get(`/organizations/${organizationId}/menus`, { params }).then((response) => {
      return response.data;
    });
  },

  /**
   * Get a single menu for an organization
   * @param {number} organizationId - Organization ID
   * @param {number} menuId - Menu ID
   * @param {Object} params - Query parameters
   * @returns {Promise}
   */
  getMenu(organizationId, menuId, params = {}) {
    return axios.get(`/organizations/${organizationId}/menus/${menuId}`, { params }).then((response) => {
      return response.data;
    });
  },

  toggleItem(organizationId, menuId, importKey, status) {
    return axios.post(`/organizations/${organizationId}/menus/${menuId}/toggle-item`, {
      import_key: importKey,
      status,
    }).then((response) => {
      return response.data;
    });
  },
};

export default OrganizationMenusAPI;
